import { Database } from 'lucide-react';

// Verificar se é ambiente de desenvolvimento
const isDevelopment = import.meta.env.VITE_ENV === 'development' || import.meta.env.DEV;

export function DevEnvironmentBanner() {
  if (!isDevelopment) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black px-4 py-1.5 text-center text-xs font-bold shadow-lg">
      <div className="flex items-center justify-center gap-2">
        <Database className="w-3.5 h-3.5 animate-pulse" />
        <span>AMBIENTE DE DESENVOLVIMENTO</span>
        <span className="bg-black/20 px-2 py-0.5 rounded text-[10px]">caruso_crm_dev</span>
        <Database className="w-3.5 h-3.5 animate-pulse" />
      </div>
    </div>
  );
}

export { isDevelopment };
